module.exports = __webpack_public_path__ + "static/media/fourWarriors-3.5a3f5c0e.png";